import { PARTICIPANTS_NAMES_CATEGORY } from 'containers/AwarenessCenter/constants'

import { RESET_WIZARD } from '../constants'

import {
  CHANGE_SENDING_REMINDERS_COUNT,
  FETCH_QUICK_LAUNCH_ASYNC,
  GET_PARTICIPANTS_INFO_ASYNC,
  SEARCH_PARTICIPANTS_INFO_ASYNC,
  SET_IS_LOCAL_NOTIFY_MANAGER_ENABLED,
  SET_IS_LOCAL_NOTIFY_MANAGER_ENABLED_WAS_CHANGED,
  SUBMIT_QUICK_LAUNCH_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    error: null,
    data: {
      participantsInfoToInclude: {},
      loader: false,
    },
    // Quick Launch
    qlData: {},
    qlError: null,
    qlLoader: false,
    qlGeneratingLoader: false,
    qlGeneratedCampaignId: null,
    sendingRemindersCount: null,
    isLocalNotifyManagerEnabled: false,
    isLocalNotifyManagerEnabledWasChanged: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case GET_PARTICIPANTS_INFO_ASYNC.INITIATE:
      case SEARCH_PARTICIPANTS_INFO_ASYNC.INITIATE:
        return {
          ...state,
          data: {
            ...state.data,
            loader: true,
          },
        }
      case GET_PARTICIPANTS_INFO_ASYNC.SUCCESS:
        return {
          ...state,
          data: {
            ...state.data,
            participantsInfoToInclude: action.payload.data,
            loader: false,
          },
          error: null,
        }
      case GET_PARTICIPANTS_INFO_ASYNC.ERROR:
      case SEARCH_PARTICIPANTS_INFO_ASYNC.ERROR:
        return {
          ...state,
          data: {
            ...state.data,
            loader: false,
          },
          error: action.error,
        }
      case FETCH_QUICK_LAUNCH_ASYNC.INITIATE:
        return {
          ...state,
          qlLoader: true,
        }
      case FETCH_QUICK_LAUNCH_ASYNC.SUCCESS:
        return {
          ...state,
          qlLoader: false,
          qlData: action.payload.data,
        }
      case FETCH_QUICK_LAUNCH_ASYNC.ERROR:
        return {
          ...state,
          qlLoader: false,
          qlError: action.error,
        }
      case FETCH_QUICK_LAUNCH_ASYNC.CANCEL:
        return {
          ...state,
          qlLoader: false,
        }
      case SUBMIT_QUICK_LAUNCH_ASYNC.INITIATE:
        return {
          ...state,
          qlGeneratingLoader: true,
        }
      case SUBMIT_QUICK_LAUNCH_ASYNC.SUCCESS:
        return {
          ...state,
          qlGeneratingLoader: false,
          qlGeneratedCampaignId: action.payload.data.id,
        }
      case SUBMIT_QUICK_LAUNCH_ASYNC.ERROR:
        return {
          ...state,
          qlGeneratingLoader: false,
          qlError: action.error,
        }
      case SUBMIT_QUICK_LAUNCH_ASYNC.CANCEL:
        return {
          ...state,
          qlGeneratingLoader: false,
        }
      case RESET_WIZARD:
        return {
          ...initialState,
        }
      case SEARCH_PARTICIPANTS_INFO_ASYNC.SUCCESS:
        let participantsInfoToInclude = {}

        if (Array.isArray(action.payload.data)) {
          action.payload.data.forEach(({ name, tag, mail }) => {
            if (!participantsInfoToInclude[tag]) {
              participantsInfoToInclude[tag] = {}
            }

            if (tag === PARTICIPANTS_NAMES_CATEGORY) {
              participantsInfoToInclude[tag][name] = {
                full_name: name,
                mail,
              }
            } else {
              participantsInfoToInclude[tag][name] = ''
            }
          })
        } else {
          participantsInfoToInclude = action.payload.data
        }

        return {
          ...state,
          data: {
            ...state.data,
            loader: false,
            participantsInfoToInclude,
          },
        }
      case CHANGE_SENDING_REMINDERS_COUNT:
        return {
          ...state,
          sendingRemindersCount: action.payload.value,
        }
      case SET_IS_LOCAL_NOTIFY_MANAGER_ENABLED:
        return {
          ...state,
          isLocalNotifyManagerEnabled: action.payload.value,
        }
      case SET_IS_LOCAL_NOTIFY_MANAGER_ENABLED_WAS_CHANGED:
        return {
          ...state,
          isLocalNotifyManagerEnabledWasChanged: action.payload.value,
        }
      default:
        return state
    }
  }
}
